import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFromLocalStorage } from "../utils/helperFunctions";
import CryptoJS from "crypto-js";

import {
    getConfigDetails as getConfigDetailsAPI,
} from "./keyService";


// const base64Encoded = "NWU0OGI5YTA0M2M0NDU5Y2JkNWYzMWNiOWI4ZDllNzc=";
// const decodedWordArray = CryptoJS.enc.Base64.parse(base64Encoded);
// const decodedString = decodedWordArray.toString(CryptoJS.enc.Utf8);

// console.log("Decoded String:", decodedString);

// const base64Encoded = "NWU0OGI5YTA0M2M0NDU5Y2JkNWYzMWNiOWI4ZDllNzc=";
// const decodedString = window.atob(base64Encoded);
// console.log("Decoded String:", decodedString);
// const decodedString = Buffer.from(base64Encoded, "base64").toString("utf-8");


// console.log("Decoded String:", decodedString);



export const getConfigDetails = createAsyncThunk(
    "key/fetchSecretKeys",
    async (_, { rejectWithValue }) => {
      try {
        const token = getFromLocalStorage("D_APP_TOKEN");
        const user_id = getFromLocalStorage("D_USER_ID");
  
        const params = {
          headers: {
            "user-id": user_id,
            Authorization: token,
            platform: "web",
            locale: 1,
          },
        };
  
        const response = await getConfigDetailsAPI(params);
  
        if (!response?.data?.data) {
          throw new Error("No secret keys found in response.");
        }
  
        // Decode each key
        const decodedKeys = {};
        Object.entries(response.data.data).forEach(([key, value]) => {
          const decodedWordArray = CryptoJS.enc.Base64.parse(value);
          decodedKeys[key] = decodedWordArray.toString(CryptoJS.enc.Utf8);
        });
  
        console.log("Decoded Keys:", decodedKeys);
  
        return decodedKeys; 
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  